import * as React from 'react';

import {
  Box,
  Typography,
  Stack,
  Card,
  CardContent,
  CardHeader
} from '@mui/material';
import { toSalary } from '../../util/SalaryDisplay';

interface teamSalaryInfoProps {
  salaryCap: number,
  currentSeasonSalary: number
}

function TeamSalaryInfo(props: teamSalaryInfoProps) {
  return <Box display="flex" justifyContent="center" width="100%">
    <Box sx={{ width: '100%', maxWidth: 500 }}>
      <Card variant="outlined">
        <CardHeader 
          title="Salary Information" 
          titleTypographyProps={{ align: 'center' }}
        />
        <CardContent>
          <Stack spacing={2}>
            <Box display="flex" justifyContent="space-between">
              <Typography>Salary Cap:</Typography>
              <Typography fontWeight="bold">
                {toSalary(props.salaryCap || 0)}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography>Current Season Salary:</Typography>
              <Typography 
                fontWeight="bold"
                color={(props.currentSeasonSalary || 0) > (props.salaryCap || 0) ? 'error' : 'inherit'}
              >
                {toSalary(props.currentSeasonSalary || 0)}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography>Remaining Cap Space:</Typography>
              <Typography 
                fontWeight="bold"
                color="success.main"
              >
                {toSalary((props.salaryCap || 0) - (props.currentSeasonSalary || 0))}
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  </Box>
}

export default TeamSalaryInfo;
